import AbstractTrigger from '@/ghost/service/Triggers/AbstractTrigger'

export default class GetReceiptTrigger extends AbstractTrigger {
  receiptWidth = 450
  receiptHeight = 550

  constructor($locator) {
    super($locator, 'getReceipt')
  }

  async onEvent() {
    this._setReceiptListeners()

    const redirectStore = this.storeFactory.create('billingRedirect', {
      width: this.receiptWidth,
      height: this.receiptHeight,
      redirectUrl: this._getReceiptUrl()
    })
    this.$store.dispatch('manualReceiptDisplay', redirectStore)
  }

  _setReceiptListeners() {
    const returnToShopListener = event => {
      if (event.data.action === 'close') {
        window.removeEventListener('message', returnToShopListener)
        // Must navigate back, otherwise in popin mode an empty modal stays open after the redirection
        this.$locator.proxy.send(
          this.$locator.storeFactory.create('navigateBack')
        )
        this.$store.dispatch('finishRedirection')
      }
    }
    window.addEventListener('message', returnToShopListener)
  }

  _getReceiptUrl() {
    const { formToken, shopId } = this.$store.state
    const { forcedDomain, ecsOrderId } = this.$store.getters
    const endpointRoot = this.endpointDetector.getEndpointRoot(formToken)
    const endpointBase =
      endpointRoot.endpoint.redirect ?? endpointRoot.endpoint.api

    const endpoint =
      forcedDomain('checkout/smartForm/ecs/web') ??
      endpointBase + `/checkout/smartForm/ecs/web`

    let url = this.restAPI.getReceiptUrl(endpoint, shopId, ecsOrderId)
    url = this.restAPI.addJSessionID(url)

    return url
  }
}
